export default __webpack_public_path__ + "static/media/boitiervert.11163e7e.svg";